import { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Container } from "../components/Container";
import { Card } from "../components/Card";
import { LoadingContainer } from "../components/LoadingContainer";
import { LoadMoreButton } from "../components/LoadMoreButton";
import { EmptyState } from "../components/EmptyState";
import { Title } from "../components/Title";
import { Button } from "../components/Button";
import { SidebarPanel } from "../components/SidebarPanel";
import { ResellerForm } from "./components/ResellerForm";
import { useGetResellersInfiniteQuery } from "../query/resellersQuery";
import { spacing } from "@styling/sizing";
import { List } from "../components/List";
import { ListItem } from "../components/ListItem";

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing.x4}px;
`;

export const ResellersView = () => {
  const { t } = useTranslation();
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const {
    data: resellersData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useGetResellersInfiniteQuery();

  const allResellers = resellersData?.pages.flatMap((page) => page) || [];

  const handleCreateResellerSuccess = () => {
    setIsPanelOpen(false);
  };

  if (isLoading && allResellers.length === 0) {
    return (
      <Container>
        <PageHeader>
          <Title>{t("listPages.resellersTitle")}</Title>
        </PageHeader>
        <LoadingContainer message={t("listPages.resellersLoading")} />
      </Container>
    );
  }

  return (
    <Container>
      <PageHeader>
        <Title>{t("listPages.resellersTitle")}</Title>
        <Button onClick={() => setIsPanelOpen(true)}>{t("listPages.addReseller")}</Button>
      </PageHeader>

      {allResellers.length === 0 ? (
        <Card>
          <EmptyState message={t("listPages.emptyResellers")} />
        </Card>
      ) : (
        <>
          <List>
            {allResellers.map((reseller) => (
              <ListItem
                key={reseller.id}
                to={`/resellers/${reseller.id}`}
                title={reseller.name}
                subTitle={t("common.listIdSubtitle", { id: reseller.id })}
              />
            ))}
          </List>
          <LoadMoreButton
            onClick={() => fetchNextPage()}
            isLoading={isFetchingNextPage}
            hasMore={hasNextPage}
          />
        </>
      )}

      <SidebarPanel
        isOpen={isPanelOpen}
        onClose={() => setIsPanelOpen(false)}
        title={t("listPages.createResellerPanel")}
      >
        <ResellerForm
          onSuccess={handleCreateResellerSuccess}
          onCancel={() => setIsPanelOpen(false)}
        />
      </SidebarPanel>
    </Container>
  );
};

